import { render, staticRenderFns } from "./PriceByUserPerSubscription.vue?vue&type=template&id=75aafe63"
import script from "./PriceByUserPerSubscription.vue?vue&type=script&lang=js"
export * from "./PriceByUserPerSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports